(function () {
  if (typeof window.ttq !== 'function' && !(window.ttq && window.ttq.track)) return;

  function track(event, payload) {
    try {
      window.ttq.track(event, payload);
    } catch (e) {}
  }

  function moneyFromCents(cents) {
    return Math.round(Number(cents || 0)) / 100;
  }

  function trackViewContent() {
    var el = document.getElementById('tiktok-product-data');
    if (!el) return;
    var product;
    try {
      product = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    track('ViewContent', {
      content_id: String(product.id),
      content_type: 'product',
      content_name: product.title,
      value: moneyFromCents(product.price),
      currency: product.currency || 'USD'
    });
  }

  function trackAddToCart(detail) {
    var cartAdd = detail && detail.cartAdd;
    if (!cartAdd) return;

    var items = cartAdd.items || [cartAdd];
    items.forEach(function (item) {
      if (!item || !item.product_id) return;
      track('AddToCart', {
        content_id: String(item.product_id),
        content_type: 'product',
        content_name: item.product_title || item.title || '',
        value: moneyFromCents(item.final_price || item.price),
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        quantity: item.quantity || 1
      });
    });
  }

  document.addEventListener('DOMContentLoaded', trackViewContent);
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cartAdd) trackAddToCart(e.detail);
  });
})();
